import {
  type Bundle,
  type BundlePaginationTokens,
  getPaginationToken,
} from '@quromedical/fhir-common';
import type { FhirResource } from 'fhir/r4';

const getPaginationTokenEncoded = <T extends FhirResource>(
  relation: 'next' | 'previous',
  bundle: Bundle<T>,
): string | undefined => {
  const pageToken = getPaginationToken(relation, bundle);
  return pageToken ? Buffer.from(pageToken).toString('base64') : undefined;
};

export const getBundlePaginationTokens = <T extends FhirResource>(
  bundle: Bundle<T>,
): BundlePaginationTokens => {
  const previousToken = getPaginationToken('previous', bundle);
  const nextToken = getPaginationToken('next', bundle);

  return {
    previousToken,
    nextToken,
  };
};

// we need to use base64 because the AWS event messes up '+' in the queryParams
export const getBundlePaginationTokensEncoded = <T extends FhirResource>(
  bundle: Bundle<T>,
): BundlePaginationTokens => {
  const previousToken = getPaginationTokenEncoded('previous', bundle);
  const nextToken = getPaginationTokenEncoded('next', bundle);

  return {
    previousToken,
    nextToken,
  };
};
